import { Autocomplete, Grid, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CommonTextField from "../../../../common/components/functional/commonTextField/CommonTextField";
import { VerticalAlignGrid } from "../../../invoices/styled";
import { useContractDataContext } from "../ContractDataProvider";
import { StyledFormSection } from "../styles";

const EezyResponsibleSection = () => {
  const { t } = useTranslation("customers");
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { expertUserOptions, orderQueues } = useContractDataContext();

  return (
    <StyledFormSection title={t("contract.eezyResponsible")}>
      <VerticalAlignGrid container spacing={1}>
        <Grid
          container
          item
          xs={3}
          justifyContent="flex-end"
          alignItems="center"
          paddingRight="0.5rem"
        >
          <Typography variant="secondary">
            {t("contract.eezySalesPerson")}
          </Typography>
        </Grid>
        <Grid item xs={5}>
          <Controller
            control={control}
            name="salesPerson"
            rules={{ required: true }}
            render={({ field }) => (
              <Autocomplete
                value={field.value}
                options={expertUserOptions.sort((a, b) =>
                  a.name.localeCompare(b.name),
                )}
                getOptionLabel={(option) => option.name}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderOption={(props, option) => (
                  <li {...props} key={option.id}>
                    {option.name}
                  </li>
                )}
                onChange={(_, newValue) => field.onChange(newValue)}
                renderInput={(params) => (
                  <CommonTextField {...params} error={!!errors[field.name]} />
                )}
              />
            )}
          />
        </Grid>
      </VerticalAlignGrid>
      <VerticalAlignGrid container spacing={1}>
        <Grid
          container
          item
          xs={3}
          justifyContent="flex-end"
          alignItems="center"
          paddingRight="0.5rem"
        >
          <Typography variant="secondary">{t("contract.workQueue")}</Typography>
        </Grid>
        <Grid item xs={5}>
          <Controller
            control={control}
            name="orderQueue"
            render={({ field: { value, onChange } }) => (
              <Autocomplete
                value={value || null}
                options={orderQueues.sort((a, b) =>
                  a.name.localeCompare(b.name),
                )}
                getOptionLabel={(option) => option.name}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(_, newValue) => onChange(newValue)}
                renderInput={(params) => <CommonTextField {...params} />}
              />
            )}
          />
        </Grid>
      </VerticalAlignGrid>
    </StyledFormSection>
  );
};

export default EezyResponsibleSection;
